import styled from 'styled-components';
import cssKit from '../../css';

export const dealersListLoadingSpinnerStyles = {
  padding: '79px 0 25px 0'
};

export const DealersListWrapperStyled = styled.div`
  position: relative;
`;

export const DealersListZipWrapperStyled = styled.div`
  position: relative;
  margin: 0 0 5px 0;
  padding: 20px 0 0;
  background-color: #fff;

  ${cssKit.media.greaterThan('small') `
    margin: 0 50px 0px 50px;
  `};
`;

export const DealersListResultsPendingStyled = styled.div`
  position: relative;
`;

export const TotalDealersStyled = styled.div`
  color: ${cssKit.vars.color_white};
  font-family: ${cssKit.fonts.regular};
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  background-color: #fff;
  text-align: center;
  padding: 15px;

  ${cssKit.media.greaterThan('small') `
  margin: 0 50px 0 50px;

  `};
`;

export const ClosestDealersTitle = styled.span`
  font-family: ${cssKit.fonts.regular};
  font-size: 1rem;
  padding-left: 3em;
`;



/** WEBPACK FOOTER **
 ** ./src/components/DealersList/styles.js
 **/